import React from 'react'
import {HiArrowNarrowRight} from 'react-icons/hi'
import {Link} from 'react-scroll'

const Home = () => {
  return (
    <div name='home' className='w-full h-screen bg-[#617ea3]'>
        {/* container */}
        <div className='max-w-[1000px] mx-auto px-4 flex flex-col justify-center h-full'>
            <p className='text-[#000000] font-bold pt-32 mt-64 sm:pt-16 sm:mt-64'>Hi! My name is</p>
            <h1 className='text-4xl sm:text-7xl font-bold text-[#1c337b]'>Shriraj Mandulapalli</h1>
            <h2 className='text-3xl sm:text-6xl font-bold text-[#0d0c1d]'>I'm an aspiring SWE / AI / ML Engineer looking for a Summer 2025 Intern Position</h2>
            <p className='text-[#000000] py-4 max-w-[700px] font-bold'>I'm a junior at Florida Polytechnic University studying Computer Science - Software Engineering.
                        I am also unofficially taking all the Machine Learning and AI concentration courses to further develop my knowledge in that area! I'm very experienced in Python, C++, and Javascript.
                        I'm being getting very familiar with tools and frameworks like Langchain, PyTorch, Scikit-Learn, Pandas, Docker, Apache Kafka, OpenCV, Transformers, Flask, FastAPI, and Seaborn. 
                        On campus, I am a ML/SWE oriented Research Assistant working on an awesome Agentic AI and LLM topic related to Software Engineering. 
                        I'm apart of SHPE (Society of Hispanic Professional Engineers) which helps develop my professional skills! I have a passion for ML and SWE and hope to
                        one day use my skills to make a product or software better while contributing to the mission of making life easier for others through the use of technology!</p>
            <div className='hidden sm:flex'>
                <button className='text-black font-bold group border-2 border-black px-6 py-3 my-2 flex items-center hover:bg-[#00a8e8] hover:border-[#00a8e8]'>
                    <Link to="projects" smooth={true} duration={500}>View Work</Link>
                    <span className='group-hover:rotate-90 duration-300'><HiArrowNarrowRight className='ml-3'/>
                    </span>
                </button>
            </div>
        </div>

    </div>
  )
}

export default Home